<template>
  <div>
    <div
      class="havepushlist clear"
      @click.stop="logdetails(journalmatter)"
      v-for="(journalmatter, inx) in pushjour"
      :key="inx"
    >
      <div>
        <div class="clear">
          <svg class="icon iconcssc" aria-hidden="true">
            <use xlink:href="#iconflow-log"></use>
          </svg>
          <div class="havepushtitle">{{ journalmatter.journal_title }}</div>
        </div>
        <div class="spanleft clear">
          <div>
            <i class="iconfont iconicon-system-fn-time-copy-copy"></i>
            <span>{{ journalmatter.create_time }}</span>
          </div>
          <div v-show="pathtype == '/space/journal'">
            <div v-show="journalmatter.draft == 1">
              <!-- <div>
                                <i class="iconfont iconliulanliang-copy"></i>
                                <span>0</span>
                            </div> -->
              <div @click.stop="journalLike(journalmatter)">
                <i
                  class="iconfont iconxin iconheartcol"
                  v-if="journalmatter.pstatus == 1"
                ></i>
                <i class="iconfont iconheart" v-else></i>
                <span>{{ journalmatter.psum }}</span>
              </div>
              <div @click.stop="logcollect(journalmatter)">
                <i
                  class="iconfont iconcollection-b-copy"
                  v-if="journalmatter.cstatus == 1"
                ></i>
                <i class="iconfont iconxingxing" v-else></i>
                <span>{{ journalmatter.colsum }}</span>
              </div>
              <!-- <div>
                                <i class="iconfont iconfenxiang1"></i>
                                <span>0</span>
                            </div> -->
              <!-- <div>
                                <i class="iconfont iconpinglun"></i>
                                <span>0</span>
                            </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="havepushfunction" v-show="isshow">
        <div
          class="collectc"
          @click.stop="logcollect(journalmatter)"
          v-show="pathtype == '/space/collection'"
        >
          <i class="iconfont xingingico iconxingxing"></i>
        </div>
        <div class="bianji" v-show="pathtype == '/space/journal'">
          <i
            class="iconfont iconbianji"
            @click.stop="redactlog(journalmatter)"
          ></i>
        </div>
        <div class="shanchu" v-show="pathtype == '/space/journal'">
          <i
            class="iconfont iconshanchu"
            @click.stop="deluppop(journalmatter)"
          ></i>
        </div>
      </div>
    </div>
    <log :pushlog="pushlog" @renoav="shareDialogVisible"></log>
  </div>
</template>
<script>
import URL from "../../api/index";
import axios from "axios";
import log from "./dialog";
export default {
  props: ["pushjour"],
  components: {
    log,
  },
  data() {
    return {
      logtype: true,
      list: 1,
      pathtype: "",
      pagenum: "15",
      isshow: true,
      iteminfo: "",
      pushlog: false,
      journal_id: "",
      draft: "",
    };
  },
  created() {
    // 获取用户信息、
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
  },
  mounted() {
    this.journal_id = "";
    this.pathtype = this.$route.path;
    window.addEventListener("scroll", this.scrollEvent, false);
    this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
    if (this.iteminfo) {
      this.isshow = false;
    } else {
      this.isshow = true;
    }
  },
  methods: {
    scrollEvent() {
      if (
        document.documentElement.scrollTop +
          document.documentElement.clientHeight >=
        document.body.scrollHeight
      ) {
        this.pagenum = Number(this.pagenum) + 15;
        this.$emit("deljou", this.pagenum);
      }
    },
    //详情页面
    logdetails(logdetails) {
      this.$router.push({
        name: "particular",
        query: {
          journalid: logdetails.journal_id,
        },
      });
    },
    //编辑日志
    redactlog(jourinfo) {
      localStorage.setItem("jourinfo", JSON.stringify(jourinfo));
      this.$router.push({
        name: "editlog",
        query: {
          edittype: 2,
        },
      });
    },
    //删除提示
    deluppop(journalmatter) {
      // console.log(journalmatter);
      this.draft = journalmatter.draft;
      this.$confirm("你确定删除吗？", "提示消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.deljournal(journalmatter);
        })
        .catch(() => {});
    },
    //删除日志
    deljournal(journalmatter) {
      var deljournaldata = {
        token: this.UserInfo.token,
        journal_id: journalmatter.journal_id,
      };
      this.$post(URL.deljournal, deljournaldata).then((res) => {
        this.getRjwDel(
          JSON.parse(localStorage.getItem("loginInfo")),
          journalmatter.journal_id
        );
        if (res.state == 0) {
          this.$emit("deljou", this.pagenum);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //日志收藏
    logcollect(journalmatter) {
      if (this.$route.path == "/space/collection") {
        this.getRjwUnCol(
          JSON.parse(localStorage.getItem("loginInfo")),
          journalmatter.dynamic_id
        );
        this.pushlog = true;
        this.journal_id = journalmatter.journal_id;
      } else {
        var collectdata = {
          coltype: "journal",
          content: journalmatter.journal_id,
          token: this.UserInfo.token,
        };
        this.$post(URL.collect, collectdata).then((item) => {
          //   this.getRecordRjw(journalmatter.journal_id, "收藏了日志");
          if (item.state == 0) {
            this.$emit("deljou", this.pagenum);
          } else {
            this.$message.error(item.msg);
          }
        });
      }
    },
    //上报数据-取消收藏
    getRjwUnCol(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_collectcancel",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的取消收藏功能",
          data: {
            function: "收藏列表",
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            bycancelcollect_id: row,
            source: "收藏的日志",
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    shareDialogVisible(val) {
      var that = this;
      if (val == 1) {
        that.pushlog = false;
      } else if (val == 2) {
        var collectdata = {
          coltype: "journal",
          content: this.journal_id,
          token: this.UserInfo.token,
        };
        this.$post(URL.collect, collectdata).then((item) => {
          if (item.state == 0) {
            this.$emit("deljou", this.pagenum);
          } else {
            this.$message.error(item.msg);
          }
        });
        that.pushlog = false;
      }
    },
    //点赞
    journalLike(journalmatter) {
      var journalLikedata = {
        token: this.UserInfo.token,
        journalid: journalmatter.journal_id,
      };
      this.$post(URL.journalLike, journalLikedata).then((item) => {
        // this.getRecordRjw(journalmatter.journal_id, "点赞了日志");
        if (item.state == 0) {
          this.$emit("deljou", this.pagenum);
        } else {
          this.$message.error(item.msg);
        }
      });
    },
    //数据上报
    getRjwDel(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_delete",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的删除功能",
          data: {
            function: "日志",
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            delete_id: row,
            source: this.draft == "1" ? "已发布" : "草稿箱",
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>
<style >
.havepushlist {
  width: 100%;
  height: 100px;
  padding: 22px 26px;
  background: #fff;
  cursor: pointer;
  margin-top: 15px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}
.havepushlist > div:nth-child(1) > div:nth-child(1) {
  margin-top: -10px;
}
.havepushlist > div:nth-child(1) > div:nth-child(2) {
  margin: 20px 0 0 30px;
}
.havepushlist > div:nth-child(1) > div:nth-child(2) div {
  float: left;
  margin-right: 30px;
}
.havepushlist > div:nth-child(1) > div:nth-child(2) div span {
  color: #898989;
  font-size: 14px;
}
.havepushlist > div:nth-child(1) {
  float: left;
}
.havepushlist > div:nth-child(2) {
  float: right;
}
.iconcssc {
  width: 34px !important;
  height: 30px !important;
  float: left;
}
.havepushtitle {
  width: 310px;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  color: #2b2b2b;
  float: left;
}
.spanleft div span {
  margin-left: 6px;
}
.havepushfunction {
  margin-top: 10px;
}
.havepushfunction div {
  width: 42px;
  height: 42px;
  float: left;
  border-radius: 50%;
  background: #ebebeb;
  cursor: pointer;
  text-align: center;
}
.havepushfunction div i {
  color: #a3a3a3;
  font-size: 28px;
  line-height: 42px;
}
.havepushfunction div:nth-child(2) {
  margin: 0 20px;
}
.collectc {
  width: 34px !important;
  height: 34px !important;
  background: #ffcd56 !important;
}
.collectc i {
  font-size: 20px !important;
  line-height: 36px !important;
}
.xingingico {
  color: #fff !important;
}

.iconcollection-b-copy {
  color: #ffcd56 !important;
}
.iconheartcol {
  color: #ff5656 !important;
}
.bianji:hover {
  background: #66b1ff !important;
}
.bianji:hover i {
  color: #fff !important;
}
.shanchu:hover {
  background: #ff5656 !important;
}
.shanchu:hover i {
  color: #fff !important;
}
</style>